/**
 * Aktualizace aplikace: service worker se registruje a pravidelně kontroluje
 * novou verzi (při návratu do aplikace a každých 30 minut). Když se nová verze
 * stáhne, ukáže se lišta „Je k dispozici nová verze – Načíst“. Sama se
 * nenačítá, aby uživatel nepřišel o rozepsaný zápis.
 */
import { useEffect, useState } from 'react';

let available = false;
const listeners = new Set<() => void>();
const announce = () => {
  available = true;
  listeners.forEach((l) => l());
};

export function installUpdates() {
  if (!('serviceWorker' in navigator)) return;
  if (location.protocol !== 'https:' && location.hostname !== 'localhost') return;
  // Při úplně první instalaci ještě žádná stará verze neběží – lišta se neukáže.
  const hadController = !!navigator.serviceWorker.controller;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) announce();
  });
  addEventListener('load', () => {
    navigator.serviceWorker
      .register('./sw.js')
      .then((reg) => {
        const check = () => {
          if (navigator.onLine) reg.update().catch(() => {});
        };
        document.addEventListener('visibilitychange', () => document.visibilityState === 'visible' && check());
        setInterval(check, 30 * 60 * 1000);
      })
      .catch(() => {});
  });
}

export function UpdateBanner() {
  const [show, setShow] = useState(available);
  useEffect(() => {
    const l = () => setShow(true);
    listeners.add(l);
    return () => void listeners.delete(l);
  }, []);
  if (!show) return null;
  return (
    <div className="update-bar no-print" role="status">
      <span>Je k dispozici nová verze aplikace.</span>
      <button className="btn small primary" onClick={() => location.reload()}>
        Načíst
      </button>
      <button className="update-close" aria-label="Později" onClick={() => setShow(false)}>
        ×
      </button>
    </div>
  );
}
